enum Seniority {
  NOT_SET = "NOT_SET",
  ASSOCIATE = "ASSOCIATE",
  CONSULTANT_SE1 = "CONSULTANT_SE1",
  CONSULTANT_SE2 = "CONSULTANT_SE2",
  SENIOR = "SENIOR",
  LEAD = "LEAD",
  SENIOR_LEAD = "SENIOR_LEAD",
  AM = "AM",
  KAM = "KAM",
  SENIOR_KAM = "SENIOR_KAM",
  LL_1 = "LL_1",
  LL_2 = "LL_2",
  LL_3 = "LL_3",
  LL_4 = "LL_4",
  LL_5 = "LL_5",
  LL_6 = "LL_6",
  LL_7 = "LL_7",
  OTHER = "OTHER",
  SENIOR_SE3 = "SENIOR_SE3",
  LEAD_SE4 = "LEAD_SE4",
  SENIOR_LEAD_SE5 = "SENIOR_LEAD_SE5",
}

export default Seniority;
